import { RegisteredDetails } from "../components/RegisteredDetails";
import { RegisterLayout } from "../components/RegisterLayout";

const Section = ({ n, title, children }) => (
  <section className="py-8 border-b border-white/10" data-testid={`accessibility-section-${n}`}>
    <div className="grid md:grid-cols-[80px_1fr] gap-4 md:gap-10">
      <span className="font-serif text-3xl text-[#B87333]/40">{n}</span>
      <div>
        <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
        <div className="font-body text-[#C9C9C2] leading-relaxed space-y-3 max-w-2xl">{children}</div>
      </div>
    </div>
  </section>
);

export default function Accessibility() {
  return (
    <RegisterLayout
      kicker="/ Legal"
      title="Accessibility Statement"
      subtitle={`Vinci Inc. is committed to ensuring digital accessibility for all users. Last reviewed ${new Date().getFullYear()}.`}
    >
      <div className="mt-4">
        <Section n="01" title="Our commitment">
          <p><strong className="text-[#F5F5F0]">Vinci Inc.</strong> is committed to making its website accessible to the widest possible audience, regardless of ability or technology, and to providing an equitable experience for all customers and partners.</p>
        </Section>
        <Section n="02" title="Conformance standard">
          <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible for people with disabilities and more usable for everyone.</p>
        </Section>
        <Section n="03" title="Measures we take">
          <p>Semantic structure and clear headings; sufficient colour contrast; keyboard-navigable interactive elements; descriptive labels and alternative text for meaningful images; and responsive layouts across devices.</p>
        </Section>
        <Section n="04" title="Ongoing effort">
          <p>Accessibility is an ongoing effort. We regularly review the site and address issues as they are identified. Some third-party components (such as the payment gateway) are provided by external vendors and are outside our direct control.</p>
        </Section>
        <Section n="05" title="Feedback & contact">
          <p>If you encounter any accessibility barrier on our website, please let us know and we will work to resolve it promptly.</p>
          <RegisteredDetails />
        </Section>
      </div>
    </RegisterLayout>
  );
}
